export const ADVERTISING_CATALOG_URL = '/advertising/catalog';

export const ADVERTISING_SHOPS_URL = '/advertising/catalog/shops';
